import { render, staticRenderFns } from "./RouteProblemDialog.vue?vue&type=template&id=2a2bb0c0"
import script from "./RouteProblemDialog.vue?vue&type=script&lang=js"
export * from "./RouteProblemDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports